import script from "./EmailPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailPreview.vue?vue&type=script&setup=true&lang=js"

import "./EmailPreview.vue?vue&type=style&index=0&id=6472d7a2&lang=css"

const __exports__ = script;

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QEditor from 'quasar/src/components/editor/QEditor.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QSelect,QInput,QEditor,QBtn});qInstall(script, 'directives', {ClosePopup});
